import React from "react"

import { useApp } from "../../../hooks/useApp"
import { useSanity } from "../../../hooks/useSanity"
import { useImage } from "../../../hooks/useImage"
import { useRoutes } from "../../../hooks/useRoutes"
import { useTemplate } from "../../../hooks/useTemplate"
import { useAccount } from "../../../hooks/useAccount"

export const withImageText = Component => ({
  name = "ImageText",
  content: rawContent,
  image: rawImage,
  link: rawLink,
  title: rawTitle,
  register,
  ...props
}) => {
  const { setRegister, setReport } = useApp()
  const { activeSubscription } = useAccount()
  const { sanityContent } = useSanity()
  const { getResponsiveImage } = useImage()
  const { linkResolver } = useRoutes()
  const { global: locales } = useTemplate()

  const handlePopup = () => setReport(true)
  const handleRegister = () => setRegister(true)

  const image = getResponsiveImage(rawImage, { maxWidth: 1000 })
  const link = linkResolver(rawLink)
  const title = sanityContent(rawTitle)
  const content = sanityContent(rawContent)

  const showRegister = register && !activeSubscription
  const showLink = link?.url && (!activeSubscription || (activeSubscription && !link?.url?.includes("/register")))

  Component.displayName = name
  return (
    <Component
      {...props}
      content={content}
      handlePopup={handlePopup}
      handleRegister={handleRegister}
      image={image}
      link={link}
      title={title}
      locales={locales}
      showRegister={showRegister}
      showLink={showLink}
    />
  )
}
